 
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    buys: [],
    summary: {
      totalCount: 0,
      totalAmount: 0
    }
  },
  loading: false,
  error: null,
};

const customePurchesReportSlice = createSlice({
  name: "customePurchesReport",
  initialState,
  reducers: {
    purchesReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    purchesReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    purchesReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPurchesReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    }
  },
});

export const {
  purchesReportRequest,
  purchesReportSuccess,
  purchesReportFailure,
  resetPurchesReport,
} = customePurchesReportSlice.actions;

export default customePurchesReportSlice.reducer;